<template>
  <div class="">
    <nav class="navbar navbar-light bg-white fixed-top blue-thick">
      <div class="col-md-12">
        <div class="row d-flex justify-content-center">
          <div class="col-md-3 ml-0 pl-0">
            <router-link to="" class="no-active">
              <img
                src="@/assets/adminlte/images/logo.png"
                class="img-fluid"
                alt=""
              />
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <section class="login-bg">
      <div class="row d-flex justify-content-center">
        <div class="col-md-6">
          <div class="mt-250" style="background-color: #fff; opacity: 100%">
            <br />
            <h5 class="ml-4">Reset Password</h5>
            <div class="card-body login-card-body">
              <b-alert show :variant="color" v-if="response_message != null">
                {{ response_message }}
              </b-alert>
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label text-md-right"
                  >E-Mail Address</label
                >

                <div class="col-md-7">
                  <input type="email" class="form-control" v-model="email" />
                </div>
                <span class="text-danger" v-if="errors.email">{{
                  this.errors.email[0]
                }}</span>
              </div>
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label text-md-right"
                  >Password</label
                >

                <div class="col-md-7">
                  <input
                    type="password"
                    class="form-control"
                    v-model="password"
                  />
                  <span class="text-danger" v-if="errors.password">{{
                    this.errors.password[0]
                  }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label text-md-right"
                  >Confirm Password</label
                >

                <div class="col-md-7">
                  <input
                    type="password"
                    class="form-control"
                    v-model="confirm_password"
                  />
                  <span class="text-danger" v-if="errors.confirm_password">{{
                    this.errors.confirm_password[0]
                  }}</span>
                </div>
              </div>
              <div class="form-group row mb-0">
                <div class="col-md-7 offset-md-4">
                  <button type="submit" class="btn btn-primary-square" @click="resetUserPassword">
                    <b-spinner
                      style="margin-left: 200px; color: #17375e"
                      label="Spinning"
                      v-if="loader"
                    ></b-spinner>
                    <b v-if="!loader"
                      >Reset Password</b>
                    <!-- <img
                      v-if="!loader"
                      src="@/assets/adminlte/images/btn/password.svg"
                      class=""
                      alt=""
                    /> -->
                  </button>
                </div>
              </div>
              <div class="row d-flex justify-content-between mt-2">
                <div class="col-xs-12 col-md-7 d-flex justify-content-end mx-0">
                  <p class="mb-1">
                    <router-link
                      to="/"
                      class="text-center"
                      href=""
                      style="
                        color: #3490dc !important;
                        text-decoration: none !important;
                        background-color: transparent !important;
                        border-bottom: none;
                      "
                      >Back To Login</router-link
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "ForgotpasswordView",
  data() {
    return {
      email: null,
      errors: [],
      response_message: null,
      loader: false,
      color: "success",
      token: null,
      password: null,
      confirm_password: null,
    };
  },
  created() {
    this.getUrlDatas();
  },
  methods: {
    getUrlDatas() {
      console.log(window.location.href);
      const route = window.location.href;

      const email_split = route.split("email=");
      const split_route = email_split[0].split("/");
      const token = split_route[5].slice(0, -1);
      this.token = token;
      this.email = email_split[1].replace("%", "");
    },
    resetUserPassword() {
      //Save or update User Details
      this.errors = [];
      // this.response_message = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/resetUserPassword";
      let method_type = "POST";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          token: this.token,
          password: this.password,
          confirm_password: this.confirm_password,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          if (data.status === true) {
            this.color = "success";
            this.response_message = data.message;
            this.password = null;
            this.confirm_password = null;
          } else {
            console.log(data.errors);
            if (data.errors) {
              this.errors = data.errors;
            } else {
              this.color = "danger";
              this.response_message = data.message;
            }
          }
        })
        .catch(function (err) {
          console.log("User Data", "Error : " + err.message, "error");
        });
    },
  },
};
</script>